<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__top push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
            <a href="/" class="back-link">Go Back</a>
        </div>
        <Form
          :data="form"
          :error="$v.form.$error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitDateOfBirth"
        >       


          <Fieldset 
            :title="question"
            type="heading">
            <div class="soft__ends">
                <TextInput
                  id="fullname"
                  name="fullname"
                  label="What is the young person's name"
                  hintText="For example, John Smith"
                  errorMessage="What is the young person's name is a required field"
                  v-model="form.fullname"
                  :validate="$v.form.fullname"
                />
            </div>    
            <div v-for="(error, index) in $v.form.$errors" :key="'errors' + index" >
              <pre>{{ error | myErrorFormatter }}</pre>
            </div>       
            <DateOfBirth 
              :validate="$v.form"
              :errorMessage="errorMessage">              
              <DateOfBirthInput id="day" name="day" label="Day" type="day" v-model="form.day" :validate="$v.form.day" />
              <DateOfBirthInput id="month" name="month" label="Month" type="month" v-model="form.month" :validate="$v.form.month" />
              <DateOfBirthInput id="year" name="year" label="Year" type="year" v-model="form.year" :validate="$v.form.year" />
            </DateOfBirth>
            <div class="soft__top">
                <TextInput
                  id="hospitalId"
                  name="hospitalId"
                  label="What is your hospital ID number"
                  hintText="The hospital ID will be shown on your letter from the clinic"
                  errorMessage="Hospital ID is a required field"
                  v-model="form.hospitalId"
                  :validate="$v.form.hospitalId"
                />
            </div>              
          </Fieldset>

          <div :class="['hidden', {'show' : age > 10 && age < 18}]">
            <Fieldset
              title="Is the young person able to answer questions on their own without any help?"
              type="default">
              <div :class="['form-group', {'form-group--error' : $v.form.withoutHelp.$error}]">
                  <span id="input-ex-withoutHelp" class="error-message" v-if="$v.form.withoutHelp.$error">Is the young person able to answer questions on their own without any help is a required field </span>
                  <div v-for="option in withoutHelp" :key="'withoutHelp' + option.id">
                      <RadioButton :label="option.label" ref="withoutHelp" name="withoutHelp" :id="'withoutHelp' + option.id" :value="option.id" :model="answer1" @change="changeWithoutHelp"/>
                  </div>
              </div>          
            </Fieldset>
          </div>

          <Fieldset
            title="Does the young person attend a specialist school/hub/unit to meet their support needs?"
            type="default">
            <div :class="['form-group', {'form-group--error' : $v.form.specialistSchool.$error}]">
                  <span id="input-ex-specialistSchool" class="error-message" v-if="$v.form.specialistSchool.$error">Does the young person attend a specialist school/hub/unit to meet their support needs is a required field </span>
                  <div v-for="option in specialistSchool" :key="'specialistSchool' + option.id">
                    <RadioButton :label="option.label" name="specialistSchool" :id="'specialistSchool' + option.id" :value="option.id" :model="answer2" @change="changeSpecialistSchool"/>
                  </div>
            </div>
          </Fieldset>
          
          <Fieldset
            title="Is the young person in receipt of any additional support for their mental health?"
            type="default">
            <div :class="['form-group', {'form-group--error' : $v.form.additionalSupport.$error}]">
                <span id="input-ex-additionalSupport" class="error-message" v-if="$v.form.additionalSupport.$error">Is the young person in receipt of any additional support for their mental health is a required field </span>
                <div v-for="option in additionalSupport" :key="'additionalSupport' + option.id">
                    <RadioButton :label="option.label" name="additionalSupport" :id="'additionalSupport' + option.id" :value="option.id" :model="answer3" @change="changeAdditionalSupport"/>
                </div>
            </div>
            <div class="soft__top" v-if="answer3 == 0">
                <Textarea
                  id="moreInformation"
                  name="moreInformation"
                  label="Please provide more information about this support"
                  errorMessage="If answered yes, please provide more information"
                  v-model="form.supportText"
                  :validate="$v.form.supportText"
                />
            </div>   
          </Fieldset>

          <div class="js-modal modal is--active" data-module="modal" v-if="showModal">
              <div class="modal__inner js-modal__dialog" role="dialog" :aria-modal="showModal" aria-labelledby="confirmation-dialog" :aria-hidden="showModal">
                  <div class="push__bottom gamma" id="confirmation-dialog">Young person's details confirmation</div>
                  <div class="align-left push__bottom wysiwyg">
                  <dl>
                    <dt><strong>Full Name</strong></dt>
                    <dd class="push__bottom">{{form.fullname}}</dd>
                    <dt><strong>Age</strong></dt>
                    <dd class="push__bottom">{{age}}</dd>
                    <dt><strong>Hospital ID</strong></dt>
                    <dd class="push__bottom">{{form.hospitalId}}</dd>
                    <dt v-if="age > 10 && age < 18"><strong>Is the young person able to answer questions on their own without any help?</strong></dt>
                    <dd v-if="age > 10 && age < 18" class="push__bottom">{{form.withoutHelp.response}}</dd>
                    <dt><strong>Does the young person attend a specialist school/hub/unit to meet their support needs?</strong></dt>
                    <dd class="push__bottom">{{ form.specialistSchool.response}}</dd>
                    <dt><strong>Is the young person in receipt of any additional support for their mental health?</strong></dt>
                    <dd class="push__bottom">
                      {{ form.additionalSupport.response}}
                    </dd>
                    <dt v-if="form.additionalSupport.response == 'Yes'"><strong>Please provide more information about this support</strong></dt>
                    <dd class="push__bottom" v-if="form.additionalSupport.response == 'Yes'">
                      {{ form.supportText}}
                    </dd>
                  </dl>
                  </div>
                  <div class="align-centre">
                      <div class="grid-col grid-col--soft push__bottom">
                        <button id="confirm" class="btn btn--primary modal-toggle-confirmation-dialog" @click="confirmDetails">Confirm Details</button>
                      </div>
                      <div class="grid-col grid-col--soft">
                        <button id="cancel" class="btn modal-toggle-confirmation-dialog" @click="cancelModal">Cancel</button>
                      </div>
                  </div>
              </div>
          </div>

        </Form>
      </article>

    </div>
  </div>
</template>

<style scoped>
  .modal.is--active {
    overflow-y: scroll;
  }
</style>

<script>

// Having issue with having to hit submit twice

import { required, requiredIf, maxValue, minValue } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "PatientDetails",
  props: {
    title: String
  },
  data() {
    return {
      selected: null,
      id: "",
      question: {},
      errorMessage: "Please ensure all questions are answered and valid.",      
      showModal: false,
      withoutHelp: [],
      additionalSupport: [], 
      specialistSchool: [],
      answer1: null,
      answer2: null, 
      answer3: null,
      age: 0, 
      form: {
        fullname: null,
        day: null,
        month: null,
        year: null,
        hospitalId: null,
        withoutHelp: [],
        specialistSchool: [],
        additionalSupport: [],
        supportText: null
      }
    };
  },
  created() {
    this.loadQuestion();
  },
  mounted() {
    this.loadAnswer();
  },
  validations: {
    form: {
      checkDate(){
        return (
          this.isValidDate(this.form.day, this.form.month, this.form.year) && this.isNotFuture(this.form.day, this.form.month, this.form.year)
        );
      },
      day: { required, minValue: minValue(1), maxValue: maxValue(31)},
      month: { required, minValue: minValue(1), maxValue: maxValue(12)},
      year: { required, minValue: minValue(1900), maxValue: maxValue(new Date().getFullYear())},
      fullname: {required},
      hospitalId: {required},
      withoutHelp : { 
        required: requiredIf(function() {
          return this.age > 10 && this.age < 18;
        })
      },
      specialistSchool : {required},
      additionalSupport : { required },
      supportText : { 
        required: requiredIf(function() {
          return this.answer3 == 0;
        })
      }
    }
	},
  methods: {
		daysInMonth(m, y) {
			switch (m) {
				case 1 :
					return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
				case 8 : case 3 : case 5 : case 10 :
					return 30;
				default :
					return 31
			}
		},
		isValidDate(d, m, y) {
			m = parseInt(m, 10) - 1;
			return m >= 0 && m < 12 && d > 0 && d <= this.daysInMonth(m, y);
		},
    cancelModal() {
      this.showModal = false;
      document.getElementsByTagName('html')[0].removeAttribute('style');
    },
    isNotFuture(d, m, y) {      
      let birthDate = new Date(y, m-1, d);
      let age = this.calculateAge(birthDate);
      this.age = age;
      return age >= 0;
    },
    calculateAge(birthDate) {
      let today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      if (today.getMonth() < birthDate.getMonth() || (today.getMonth() == birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    changeWithoutHelp: function(newValue) {
        this.answer1 = this.withoutHelp[newValue].id;
        this.form.withoutHelp = this.withoutHelp[newValue];
    },
    changeSpecialistSchool: function(newValue) {
      this.answer2 = this.specialistSchool[newValue].id;
      this.form.specialistSchool = this.specialistSchool[newValue];
    },
    changeAdditionalSupport: function(newValue) {
        this.answer3 = this.additionalSupport[newValue].id;
        this.form.additionalSupport = this.additionalSupport[newValue];
    },
    submitForm(form, valid) {
			valid.$touch();
      if (valid.$pending || valid.$error) {
				setTimeout(() => {
					document.querySelector(".error-summary__link").focus()
				}, 0);
				return;	
			}
      let year = form.year.toString();
      let month = form.month.toString();
      let day = form.day.toString();
      let birthDate = new Date(year, month-1, day);
      this.age = this.calculateAge(birthDate);
      this.showModal = true;
      document.getElementsByTagName('html')[0].style.overflow = "hidden";
    },
    submitDateOfBirth() {
      this.submitForm(this.form, this.$v.form);
    },
    confirmDetails() {      
      let newLocation = "/NotEligible";
      if(this.age < 5 || this.age > 17 ) {
        newLocation = "/NotEligible";
      } else {
        if (this.age >= 5 && this.age < 11) {
          newLocation = "/PreQuestionnaire5To10";
        } else if (this.age > 10 && this.age < 18 && this.form.withoutHelp.response == "Yes") {
          newLocation = "/PreQuestionnaire11to17";
        } else {          
          newLocation = "/PreQuestionnaire11To17withHelp";
        }
      }
      this.logResponse();
      document.getElementsByTagName('html')[0].removeAttribute('style');
      this.$router.push({ path: newLocation });

    },
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.question = currentQuestion.question;
      this.withoutHelp = currentQuestion.withoutHelp;
      this.additionalSupport = currentQuestion.additionalSupport;
      this.specialistSchool = currentQuestion.specialistSchool;
    },
    async loadAnswer() {
      await this.$nextTick();
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      console.log(previousResponse);
      if (previousResponse) {
        this.form.day = previousResponse.day;
        this.form.month = previousResponse.month;
        this.form.year = previousResponse.year;
        this.form.fullname = previousResponse.fullname;
        this.form.hospitalId = previousResponse.hospitalId;
        this.form.supportText = previousResponse.supportText;
        
        var needHelp = previousResponse.withoutHelp === "Yes" ? 0 : 1;
        var withoutHelpRadio = document.getElementById('withoutHelp' + needHelp);
        withoutHelpRadio.checked = true;        
        this.changeWithoutHelp(needHelp);

        var specialistSchoolPrevious = previousResponse.specialistSchool === "Yes" ? 0 : previousResponse.specialistSchool === "No" ? 1 : 2;
        var specialistSchoolRadio = document.getElementById('specialistSchool' + specialistSchoolPrevious);
        specialistSchoolRadio.checked = true;
        this.changeSpecialistSchool(specialistSchoolPrevious);

        var additionalSupportPrevious = previousResponse.additionalSupport === "Yes" ? 0 : 1;
        var additionalSupportRadio = document.getElementById('additionalSupport' + additionalSupportPrevious);
        additionalSupportRadio.checked = true;
        this.changeAdditionalSupport(additionalSupportPrevious);

      }
    },
    logResponse() {
      let questionnaire;
      if (this.age >= 5 && this.age < 11) {
          questionnaire = "Questionnaire5To10";
        } else if (this.age > 10 && this.age < 18 && this.form.withoutHelp.response == "Yes") {
          questionnaire = "Questionnaire11To17";
        } else if(this.age > 10 && this.age < 18 && this.form.withoutHelp.response == "No"){          
          questionnaire = "Questionnaire11to17WithHelp";
      }
      let response = {
        id: this.id,
        questionType: "PatientDetails",
        day: this.form.day,
        month: this.form.month,
        year: this.form.year,
        fullname: this.form.fullname,
        hospitalId: this.form.hospitalId,
        withoutHelp: this.form.withoutHelp.response,
        specialistSchool: this.form.specialistSchool.response,
        additionalSupport: this.form.additionalSupport.response,
        supportText: this.answer3 == 0 ? this.form.supportText : '',
        questionnaire: questionnaire,
        age: this.age
      };
      dataService.logResponse(response);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>